import { accordion, banner, comboBox, datePicker, header } from '@18f/identity-design-system';

const components = [accordion, banner, comboBox, datePicker, header];
components.forEach((component) => component.on());
